import React, { PropTypes } from 'react';

import styled from 'styled-components';

const GriddleAction = styled.span`
  font-size: 12px;
  color: ${props => props.theme.color.secondary};
`;

const TextConcat = ({ content }) => {
  return (
    <GriddleAction>
      {content.join(' ')}
    </GriddleAction>
  );
};

TextConcat.propTypes = {
  content: PropTypes.array
};
export default TextConcat;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/TextConcat.js